<template>
	<slot name="icon">
		<span v-if="typeof icon === 'string'" class="ht-icon sidebar-icon">
			{{ icon }}
		</span>
	</slot>
	<span class="menu-item-label">{{ label }}</span>
</template>

<script setup lang="ts">
defineProps<{
	icon?: string;
	label: string;
}>();
</script>

<style lang="scss">
.sidebar-icon {
	--icon-size: 1.25rem;

	font-size: var(--icon-size);
	width: var(--icon-size);
	height: var(--icon-size);

	svg {
		width: var(--icon-size);
		height: var(--icon-size);
		max-width: unset;
	}
}
</style>
